import { kebabCase } from "lodash";

import { i18n } from "@/plugins/i18n";

export const defaultTheme = {
  // 品牌色
  brandBtnColor: "#000000", // 按钮颜色
  brandPriceColor: "#000000", // 价格
  // 中立色
  dividerColor: "#EEEEEE",
  borderColor: "#E6E6E6",
  backgroundColor: "#FAFAFA",
  iconGrayColor: "#ABABAB",
  iconColor: "#ABABAB",
  titleTextColor: "#292929",
  textColor: "#292929",
  descriptionTextColor: "#949494",
  textDefaultColor: "#696969",
  // 功能色
  errorColor: "#F52743",
  successColor: "#01C39D",
  doneColor: "#00B4E9",

  // 运营

  // 字体
  regularFont: "Barlow-Regular",
  mediumFont: "Barlow-Medium",
  boldFont: "Barlow-SemiBold",
  priceFont: "BarlowCondensed-SemiBold",
  titleFont: "Cormorant-Bold", // 针对title的字体
  titleFontZh: "SourceHanSerifCN-SemiBold",
  titleFontZhtw: "SourceHanSerifTW-SemiBold",
  titleFontJp:"SourceHanSansJP-Medium",

  // 字体尺寸
  titleSizeLarge: "32px",
  titleSizeMedium: "24px",
  titleSizeSmall: "20px",
};

const formatName = name => {
  return "--y-" + kebabCase(name);
};

export const initTheme = () => {
  const locale = i18n.global.locale.value;
  const themeData = defaultTheme;
  let cssVariables = "";
  Object.keys(themeData).map(key => {
    const name = formatName(key);
    let value = themeData[key];
    const titleUpdateLocale = ['zh','zh_TW','jp']
    const titleFontMap = {
      'zh':'titleFontZh',
      'zh_TW':'titleFontZhtw',
      'jp' : 'titleFontJp'
    }
    if (titleUpdateLocale.includes(locale)) {
      switch (key) {
        case "titleFont":
          value = themeData[titleFontMap[locale]] || value;
          break;
        default:
          break;
      }
    }
    cssVariables += `${name}:${value};\n`;
  });

  const styleText = `
  @charset "UTF-8";
  :root{
    ${cssVariables}
  }
  `;

  if (document.querySelector("#css-variable")) {
    document.querySelector("#css-variable").innerHTML = styleText;
  } else {
    const style = document.createElement("style");
    style.type = "text/css";
    style.id = "css-variable";
    style.innerHTML = styleText;
    document.head.appendChild(style);
  }
};
